import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetFullOrderOptions } from '~/features/orders/queries';
import { Section } from '~/shared/section/Section';
import { useOrderIdParam } from '~/pages/orders/routes';
import { Order } from '~/features/orders/Order';
import { Button } from '~/shared/components/buttons/Button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function PatientOrderRoute() {
	const orderId = useOrderIdParam();
	const { data: fullOrder, refetch } = useSuspenseQuery(useGetFullOrderOptions(orderId));

	return (
		<div className="space-y-10">
			<Section>
				<div className="flex  justify-between">
					<Button Icon={ChevronLeft} label="Previous Order" appearance="outline" />
					<Button Icon={ChevronRight} label="Next Order" appearance="outline" />
				</div>
			</Section>
			<Order fullOrder={fullOrder} />
		</div>
	);
}
